import { COPY_POLICIES, DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const HERO_MEDIA_CENTERED_MAX_LENGTHS = {
    title: COPY_POLICIES.title.maxLength,
    description: COPY_POLICIES.description.maxLength,
};
/**
 * The one output size the picture is framed to, derived from the design: the
 * prototype frames the media in a 300x220 box under `object-fit: cover`, so the
 * slot's output is that box at 2x for a high-DPI screen.
 *
 * ONE target, deliberately. The picture is small and identical on every screen,
 * so there is nothing to art-direct — per-screen pictures are the Media block's
 * shape, and several framings of one picture are the multi-target shape, whose
 * all-or-nothing size floor this slot does not want.
 *
 * A stored reference names its framing BY SIZE, so this number is a contract:
 * changing it orphans every reference already stored.
 *
 * A VIDEO ignores this. It is served as uploaded — no rendition, no size floor —
 * and the box's 15:11 shape is imposed by CSS, so a clip of another shape is
 * covered into it and loses its edges. There is no framing step to choose which
 * edges, which is worth knowing when choosing a clip rather than a photograph.
 */
export const HERO_MEDIA_CENTERED_TARGET = {
    width: 600,
    height: 440,
    aspectRatio: "15:11",
};
export const heroMediaCenteredSchema = {
    componentId: "HeroMediaCentered",
    scalarSlots: [
        { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
        {
            key: "description",
            ...DESCRIPTION_COPY_LIMITS,
            label: "Description",
            type: "textarea",
        },
        { key: "ctaLabel", label: "Button label", type: "text" },
        { key: "ctaHref", label: "Button link", type: "url" },
    ],
    mediaSlots: [
        {
            key: "media",
            label: "Hero media",
            // Either kind belongs in a page's opening: a photograph of a clinic and a
            // few seconds of one in use say the same thing at different speeds, and
            // this box is where a page makes its first impression.
            accepts: ["image", "video"],
            // Decoration, not something to watch. The box is small and sits under the
            // copy the visitor came to read, so a clip here is atmosphere: it loops
            // silently, offers nothing to press, and is still for anyone who asked
            // for less motion. A player's controls would also crowd a 300x220 box.
            playback: "loop",
            targets: [{ ...HERO_MEDIA_CENTERED_TARGET }],
        },
    ],
};
//# sourceMappingURL=hero-media-centered.js.map